var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "evenodd",
    d: "M10.762 1.261c.36.36.388.928.083 1.32l-.083.094-7.402 7.403 7.402 7.402c.36.36.388.928.083 1.32l-.083.094c-.36.361-.928.389-1.32.084l-.094-.084-8.11-8.11c-.36-.36-.388-.927-.083-1.32l.083-.093 8.11-8.11c.39-.39 1.023-.39 1.414 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftUnavailable);
export default __webpack_public_path__ + "static/media/arrow-left-unavailable.83900ee1a52c190664b31ee4a184ce5f.svg";
export { ForwardRef as ReactComponent };